import React from 'react';
import * as RadixContextMenu from '@radix-ui/react-context-menu';

import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';
import { LayoutFill } from '../layout-fill/LayoutFill';
import { Text } from '../text/Text';

import { ItemOwnProps } from './item-props';

import './ContextMenuItem.less';

type ItemProps = React.ComponentPropsWithoutRef<typeof RadixContextMenu.Item> & ItemOwnProps;

const block = bemBlock('n-context-menu-item');

export const ContextMenuItem = React.forwardRef<
  React.ElementRef<typeof RadixContextMenu.Item>,
  ItemProps
>(function ContextMenuItem(
  { className, children, leadingIcon, trailingElement, active, destructive, ...props },
  ref,
) {
  return (
    <RadixContextMenu.Item
      ref={ref}
      className={block({
        extra: className,
        modifiers: { active, destructive },
      })}
      {...props}
    >
      <Layout.Row span="auto" alignItems="center" spacedChildren="sm" width="100%">
        {leadingIcon}
        <Text size="sm">{children}</Text>
        {trailingElement && <LayoutFill />}
        {trailingElement}
      </Layout.Row>
    </RadixContextMenu.Item>
  );
});
